import _ from 'underscore';
import ModalPopupView from 'views/main/Modal/ModalPopupView';
import customFooterHtml from 'templates/device/ModalActiveTrackerFooterView.html';
import { getFaqLink } from '../../../utils/LinksUtil';

var Events = {
    ON_SET: 'ON_SET'
};

var ModalActiveActivityTrackerView = ModalPopupView.extend({
    events: {
        'click .set-active': 'onSetActiveClicked',
        'click .close': 'close' // Defined in the parent
    },

    initialize: function(args) {
        args.learnMoreUrl = getFaqLink('e3gcLbODQF0jUrDnB7FGK8');
        ModalPopupView.prototype.initialize.call(this, args);
    },

    footerTemplate: _.template(customFooterHtml),

    onSetActiveClicked: function() {
        this.trigger(Events.ON_SET);
        this.close();
    }
});

ModalActiveActivityTrackerView.Events = Events;
export default ModalActiveActivityTrackerView;
